import { render, staticRenderFns } from "./OrderKidsHistoryDialog.vue?vue&type=template&id=b57a147c&scoped=true"
import script from "./OrderKidsHistoryDialog.vue?vue&type=script&lang=js"
export * from "./OrderKidsHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsHistoryDialog.vue?vue&type=style&index=0&id=b57a147c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a147c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57a147c')) {
      api.createRecord('b57a147c', component.options)
    } else {
      api.reload('b57a147c', component.options)
    }
    module.hot.accept("./OrderKidsHistoryDialog.vue?vue&type=template&id=b57a147c&scoped=true", function () {
      api.rerender('b57a147c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsHistoryDialog.vue"
export default component.exports